module.exports = __webpack_public_path__ + "img/question.a7f0912a.png";